var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.036 6.99995C11.036 8.15495 9.90269 9.08829 8.50019 9.08829C7.09769 9.08829 5.96436 8.15495 5.96436 6.99995C5.96436 5.84495 7.09769 4.91162 8.50019 4.91162C9.90269 4.91162 11.036 5.84495 11.036 6.99995Z",
    stroke: "#9A9A9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49989 11.8242C11.0003 11.8242 13.3307 10.6109 14.9528 8.51088C15.5903 7.68838 15.5903 6.30588 14.9528 5.48338C13.3307 3.38338 11.0003 2.17004 8.49989 2.17004C5.99947 2.17004 3.66906 3.38338 2.04697 5.48338C1.40947 6.30588 1.40947 7.68838 2.04697 8.51088C3.66906 10.6109 5.99947 11.8242 8.49989 11.8242Z",
    stroke: "#9A9A9A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2401eee81a4f1df0ac9df6083e2a8d12.svg";
export { ForwardRef as ReactComponent };